import { Outlet } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'

import { GoogleMapsProvider } from 'modules/core/components/GoogleMaps/GoogleMapsProvider'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import hasFeature from 'modules/core/lib/hasFeature'

import WorkplacesComponent from '../Locations/Workplaces'

const NewLocationPage = () => {
  const { featureAvailability: hasGeofencingFeatureAvailability } = useFeatureAvailability(
    Features.time_tracking_geofencing_alerts
  )

  const hasGeofencingFeature = hasGeofencingFeatureAvailability.available
  const hasGeoBlockingFeature = hasFeature('dev_time_tracking_geofencing_block')

  return (
    <GoogleMapsProvider mapsEnabled={hasGeofencingFeature || hasGeoBlockingFeature}>
      <WorkplacesComponent>
        <Outlet />
      </WorkplacesComponent>
    </GoogleMapsProvider>
  )
}

export default NewLocationPage
